import React, { FC } from "react";
import Checkbox from "../Checkbox";
import FormControlLabel, { FormControlLabelProps } from "../FormControlLabel";

const SimpleCheckbox: FC<Omit<FormControlLabelProps, "control">> = (props) => {
  return <FormControlLabel control={<Checkbox disableRipple />} {...props} />;
};

export default SimpleCheckbox;
